export const TOKEN_STORAGE = 'master_admin_token_storage'

export const ONE_BUTTON = 'one_button'
export const TWO_BUTTONS = 'two_buttons'
export const THREE_BUTTONS = 'three_buttons'




// WEBPACK FOOTER //
// ./src/helpers/Constants/index.js